<div class="table-actions">
  <div class="table-actions-left">

    <mat-form-field class="search-field" appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="currentSearchValue" placeholder="Name, Email, DCO or Role" (input)="onSearch()" />
      <button *ngIf="currentSearchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <i class="fa-duotone fa-solid fa-circle-xmark"></i>
      </button>
    </mat-form-field>

    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Filter</mat-label>
      <mat-select [(ngModel)]="currentFilterSelection" (selectionChange)="onFilterChange()">
        <mat-option *ngIf="currentFilterSelection !== null" [value]="null"><i class="fa-solid fa-xmark" style="margin-right: 8px;"></i>(Clear Filter)</mat-option>
        <mat-optgroup label="Dental Care Organizations">
          <mat-option *ngFor="let dco of availableDcos" [value]="dco.id">
            <i class="fa-solid fa-tooth" style="margin-right: 8px;"></i>
            {{ dco.displayName || dco.name || ('DCO #' + dco.id) }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <!-- Roles Filter (multi-select) -->
    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Roles</mat-label>
      <mat-select multiple
                  [(ngModel)]="selectedRoleIds"
                  (selectionChange)="onRolesFilterChange()">
        <mat-option *ngIf="selectedRoleIds?.length" (click)="$event.stopPropagation()" (mousedown)="$event.preventDefault()" (keydown)="$event.preventDefault()" (keyup)="$event.preventDefault()" [disabled]="true">
          <em>Selected: {{ roleNamesByIds(selectedRoleIds) }}</em>
        </mat-option>
        <mat-option *ngFor="let role of availableRoles" [value]="role.id">
          <i [ngClass]="getRoleIcon(role.name)" style="margin-right: 8px;"></i>
          {{ role.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Match mode: ANY / ALL -->
    <mat-form-field class="filter-field" appearance="fill" *ngIf="selectedRoleIds?.length">
      <mat-label>Role Match</mat-label>
      <mat-select [(ngModel)]="roleMatch" (selectionChange)="onRolesFilterChange()">
        <mat-option value="any">Any selected</mat-option>
        <mat-option value="all">All selected</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- User Type (All/Internal/External) -->
    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Internal/External Users</mat-label>
      <mat-select [(ngModel)]="userType" (selectionChange)="onUserTypeChange()">
        <mat-option value="all">
          <i class="fa-solid fa-users" style="margin-right: 8px;"></i>
          All users
        </mat-option>
        <mat-option value="internal">
          <i class="fa-solid fa-building" style="margin-right: 8px;"></i>
          Internal only
        </mat-option>
        <mat-option value="external">
          <i class="fa-solid fa-globe" style="margin-right: 8px;"></i>
          External only
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-chip-set class="active-filters" *ngIf="hasActiveFilters()">
      <!-- Search Chip -->
      <mat-chip *ngIf="currentSearchValue && currentSearchValue.length >= 3" removable (removed)="clearSearch()">
        Search: "{{ currentSearchValue }}"
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Filter Chip -->
      <mat-chip *ngIf="currentFilterSelection" removable (removed)="clearFilter()">
        Filter: {{ displayFilterName(currentFilterSelection) }}
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Roles Chip -->
      <mat-chip *ngIf="selectedRoleIds?.length" removable (removed)="clearRolesFilter()">
        Roles ({{ roleMatch.toUpperCase() }}): {{ roleNamesByIds(selectedRoleIds) }}
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- User Type chip -->
      <mat-chip *ngIf="userType !== 'all'" removable (removed)="userType = 'all'; applyFilter()">
        User Type: {{ userType | titlecase }}
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Clear All Chip (optional) -->
      <mat-chip *ngIf="(currentSearchValue && currentSearchValue.length >= 3) && currentFilterSelection"
                removable (removed)="resetAllFilters()">
        Clear All
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>
    </mat-chip-set>

    <mat-slide-toggle [(ngModel)]="filtersEnabled" (change)="applyFilter()" class="toggle-filter">
      Toggle Filters
    </mat-slide-toggle>

  </div>
  <div class="table-actions-right">
    <button mat-stroked-button (click)="toggleShowClosed()">
      <i class="fa-sharp-duotone" [ngClass]="{'fa-eye': showClosed, 'fa-eye-slash': !showClosed}"></i>
      {{ showClosed ? 'Hide Inactive' : 'Show Inactive' }}
    </button>
  </div>
</div>



<table mat-table [dataSource]="usersDataSource" matSort class="user-table mat-elevation-z8">

  <!-- First Name -->
  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
    <td mat-cell *matCellDef="let user"> {{ user.firstName }} </td>
  </ng-container>

  <!-- Last Name -->
  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
    <td mat-cell *matCellDef="let user"> {{ user.lastName }} </td>
  </ng-container>

  <!-- Email -->
  <ng-container matColumnDef="emailAddress">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
    <td mat-cell *matCellDef="let user"> {{ user.emailAddress }} </td>
  </ng-container>

  <!-- DCO -->
  <ng-container matColumnDef="dco">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> DCO </th>
    <td mat-cell *matCellDef="let user"> {{ user.dentalCareOrganizationDisplayName }} </td>
  </ng-container>

  <!-- Roles -->
  <ng-container matColumnDef="roles">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Roles </th>
    <td mat-cell *matCellDef="let user">
      <span *ngFor="let role of user.roles; let last = last">
        {{ role.name }}<span *ngIf="!last">, </span>
      </span>
    </td>
  </ng-container>

  <!-- User Type -->
  <ng-container matColumnDef="userType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header"> Type </th>
    <td mat-cell *matCellDef="let user">
      <span *ngIf="isInternalEmail(user.emailAddress)">
        <i class="fa-solid fa-building internal-icon" style="margin-right: 4px;"></i> Internal
      </span>
      <span *ngIf="!isInternalEmail(user.emailAddress)">
        <i class="fa-solid fa-globe external-icon" style="margin-right: 4px;"></i> External
      </span>
    </td>
  </ng-container>

  <!-- Active -->
  <ng-container matColumnDef="isActive">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header"> Active </th>
    <td mat-cell *matCellDef="let user">
      <i *ngIf="user.isActive" class="fa-solid fa-circle-check active-icon" title="Active"></i>
      <i *ngIf="!user.isActive" class="fa-solid fa-circle-xmark inactive-icon" title="Inactive"></i>
    </td>
  </ng-container>

  <!-- Actions (no sort header) -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let user">
      <button mat-icon-button color="primary" (click)="editUser(user)">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
